export default __webpack_public_path__ + "static/media/next-icon.1a235082.svg";